import type { IResource } from "@gettactic/api";

/**
 * Merges a resource with its schedulable (availability) entry.
 *
 * A resource absent from the schedulable list normally means it genuinely
 * isn't bookable in the window, so it's shown as unavailable. That only holds
 * when the list is a real answer: while the lookup is still pending (or idle,
 * waiting for a full start/end window) or has failed, every resource is
 * "absent", and forcing them all unavailable would make the whole office read
 * as booked. In that case the resource is returned untouched.
 */
export const mergeSchedulableResource = (
  resource: IResource,
  schedulableResource: IResource | undefined,
  isAvailabilityKnown: boolean
): IResource => {
  if (schedulableResource) {
    return {
      ...resource,
      ...schedulableResource,
      label: resource.label,
      description: resource.description
    };
  }
  if (!isAvailabilityKnown) {
    return resource;
  }
  return { ...resource, available_slots: 0, is_available: false };
};
